import moment from 'moment'
moment.suppressDeprecationWarnings = true;

export const dateFormatter = pDate => {
  const _date = moment.utc(pDate).local()
  const locale = window.localStorage.language || 'en-GB'
  const date = new Date(_date).toLocaleDateString(locale, {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric'
  })
  return date
}

export const dateLongMonthFormatter = pDate => {
  const _date = moment.utc(pDate).local()
  const locale = window.localStorage.language || 'en-GB'
  const date = new Date(_date).toLocaleDateString(locale, {
    day: '2-digit',
    month: 'long',
    year: 'numeric'
  })
  return date
}

export const dateTimeFormatter = pDate => {
  const _date = moment.utc(pDate).local()
  const locale = window.localStorage.language || 'en-GB'
  const date = new Date(_date).toLocaleString(locale, {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit'
  })
  return date
}

export const timeFormatter = pDate => {
  const _date = moment.utc(pDate).local()
  const locale = window.localStorage.language || 'en-GB'
  const date = new Date(_date).toLocaleTimeString(locale, {
    hour: '2-digit',
    minute: '2-digit'
  })
  return date
}

export const getISODateString = pDate => {
  const date =
    pDate.getFullYear() +
    '-' +
    ('0' + (pDate.getMonth() + 1)).slice(-2) +
    '-' +
    ('0' + pDate.getDate()).slice(-2)
  return date
}

export const getISODateTimeString = pDate => {
  const date =
    pDate.getFullYear() +
    '-' +
    ('0' + (pDate.getMonth() + 1)).slice(-2) +
    '-' +
    ('0' + pDate.getDate()).slice(-2) +
    ' ' +
    ('0' + pDate.getUTCHours()).slice(-2) +
    ':' +
    ('0' + pDate.getUTCMinutes()).slice(-2)
  return date
}

export const getISOTimeString = pDate => {
  const date =
    ('0' + pDate.getUTCHours()).slice(-2) +
    ':' +
    ('0' + pDate.getUTCMinutes()).slice(-2)
  return date
}

export const metersToFeetDecimal = pLength => {
  if (pLength !== null) {
    return pLength * 3.28084;
  }
  return null
}

export const feetToMetersDecimal = pLength => {
  if (pLength !== null) {
    return pLength / 3.28084;
  }
  return null
}

export const metersToFeet = pLength => {
  if (pLength !== null) {
    // let ft = parseInt(((pLength * 39.37) / 12), 10)
    // let inch = parseInt(((pLength * 39.37) % 12), 10)
    // return ft + '\' ' + inch + '\"'

    // convert meters to inches
    let inches = 39.3701 * pLength

    // get total feet; each foot is 12 inches
    let feet = Math.floor(inches / 12)

    // remaining inches
    let remaininginches = Math.round(inches % 12)

    if (remaininginches === 12) {
      feet += 1
      remaininginches = 0
    }
    return `${feet}' ${remaininginches}"`
  }
  return null
}

export const vdvMetersToFeet = pLength => {
  if (pLength !== null) {
    // let ft = parseInt(((pLength * 39.37) / 12), 10)
    // let inch = parseInt(((pLength * 39.37) % 12), 10)
    // return ft + '\' ' + inch + '\"'

    // convert meters to inches
    let inches = 39.3701 * pLength

    // get total feet; each foot is 12 inches
    let feet = Math.floor(inches / 12)

    // remaining inches
    let remaininginches = (feet >= 100) ? 0 : Math.round(inches % 12)

    if (remaininginches === 12) {
      feet += 1
      remaininginches = 0
    }
    return `${feet}' ${remaininginches}"`
  }
  return null
}

export const vdvPicofaradsUnitConversion = (pLength) => {
  if (pLength !== null) {
    // converting pF/m to pF/ft
    let picofaradsFoot = 0.3048 * pLength
    picofaradsFoot = Math.round(picofaradsFoot * 100) / 100
    return `${getFormattedNumberWithPrecision(picofaradsFoot, 1)}`
  }
  return null
}

export const picofaradsUnitConversion = (pLength) => {
  if (pLength !== null) {
    // converting pF/m to pF/ft
    let picofaradsFoot = 0.3048 * pLength
    picofaradsFoot = Math.round(picofaradsFoot * 100) / 100
    return `${getFormattedNumber(picofaradsFoot)}`
  }
  return null
}

export const getFormattedNumber = (value) => {
  // return number with 2 decimal value
  if (value === undefined || value === null) {
    return value
  }
  return ((Math.round(value * 100) / 100).toFixed(2))
}

export const getFormattedNumberWithPrecision = (value, fractionDigits) => {
  // return number with specified decimal value
  if (value === undefined || value === null) {
    return value
  }
  let factor = fractionDigits <= 0 ? 100 : Math.pow(10, fractionDigits);
  return ((Math.round(value * factor) / factor).toFixed(fractionDigits));
}

export const getDash = () => {
  const dashCode = '&#8212;';
  const parser = new DOMParser();
  return parser.parseFromString(dashCode, "text/html").body.textContent;
}

export const isSignalTEK10GType = (type) => {
  return type === 'signaltek10g' || type === 'signaltekqt' || type === 'signaltekqtpro' || type === 'navitek' || type === 'navitekpro';
}

export const isVDVType = (type) => {
  return type === 'vdvii' || type === 'vdviiplus' || type === 'vdviipro' || type === 'poepro';
}

export const isSignalTEKQTType = (type) => {
  return type === 'signaltekqt' || type === 'signaltekqtpro';
}

export const isNaviTEKType = (type) => {
  return type === 'navitek' || type === 'navitekpro';
}

export const isCometType = (type) => {
  return type === 'comet_copper' || type === 'comet_fiber';
}

export const getSignalTEKPreset = (type) => {
  if (isSignalTEKQTType(type)) {
    return "SignalTEKQT";
  }
  else if (isNaviTEKType(type)) {
    return "NaviTEK";
  }
  return "SignalTEK10G";
}

export const getTreeviewNodeCategory = (type) => {
  switch (type) {
    case 'comet_copper':
    case 'comet_fiber':
      return 'comet';

    case 'signaltekqt':
    case 'signaltekqtpro':
      return 'signaltekqt';
    
    case 'navitek':
    case 'navitekpro':
      return 'navitek';

    default: break;
  }
  return type;
}

export const getWiremapImageUrl = (wiremapSubtestData, measurementUnit) => {
  let wiremapImage = wiremapSubtestData ? wiremapSubtestData.imageurl : null;
  if (measurementUnit === "feet") {
    return wiremapSubtestData && wiremapSubtestData.imageurlft && wiremapSubtestData.imageurlft.length ? wiremapSubtestData.imageurlft : wiremapImage;
  }
  return wiremapImage;
}

export const isNumber = (str) => {
  return !isNaN(str) && isFinite(str);
}

export const frequecyMHzToGHz = (frequency) => {
  if (!isNumber(frequency)) {
    return "-";
  }
  return parseInt(frequency, 10) / 1000.0;
}



// WEBPACK FOOTER //
// ./src/common/utils.js